import { SxProps, Theme } from '@mui/material/styles';

function scrollbarThumbColor(theme: Theme, hover = false): string {
  if (hover) {
    return theme.palette.mode === 'light' ? theme.palette.grey[500] : theme.palette.grey[500];
  }
  return theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
}

/** Global thin scrollbar styling (Firefox + WebKit). Applied via MuiCssBaseline. */
export function getGlobalScrollbarStyleOverrides(theme: Theme) {
  const thumb = scrollbarThumbColor(theme);
  const thumbHover = scrollbarThumbColor(theme, true);

  return {
    html: {
      scrollbarWidth: 'thin',
      scrollbarColor: `${thumb} transparent`,
    },
    body: {
      scrollbarWidth: 'thin',
      scrollbarColor: `${thumb} transparent`,
    },
    '*': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${thumb} transparent`,
    },
    '*::-webkit-scrollbar': {
      width: 8,
      height: 8,
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '*::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      backgroundColor: thumb,
      border: '2px solid transparent',
      backgroundClip: 'padding-box',
    },
    '*::-webkit-scrollbar-thumb:hover': {
      backgroundColor: thumbHover,
    },
  };
}

/** Optional layout helpers for scroll regions (scrollbar appearance comes from global baseline). */
export const scrollContainerSx: SxProps<Theme> = {
  overflowX: 'hidden',
  scrollbarGutter: 'stable',
};
